function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".a{fill:none;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.615,15.249l-3.676-1.838C16.832,11.624,16.993,8.181,17,8.02V8l-.007-3.082C16.62,2.675,14.051,1,12,1h0a4.971,4.971,0,0,0-2,.479h0A5.014,5.014,0,0,0,8,1H8C5.95,1,3.379,2.676,3,5V8.02c.007.157.161,3.544,2.075,5.383l-3.69,1.846A2.489,2.489,0,0,0,0,17.489V18a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1v-.511A2.489,2.489,0,0,0,18.615,15.249ZM19,18H5v-.511a1.494,1.494,0,0,1,.832-1.346l4.392-2.2a.5.5,0,0,0,.045-.868C8.176,11.744,8,8.018,8,8L7.993,5.082A4.3,4.3,0,0,1,12,2a4.312,4.312,0,0,1,4,3V7.988c-.011.2-.23,3.873-2.256,5.083a.5.5,0,0,0,.032.876l4.392,2.2A1.494,1.494,0,0,1,19,17.489Z",
  transform: "translate(0 -0.001)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  className: "a",
  width: 20,
  height: 20
});

var SvgClientsSelected = function SvgClientsSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgClientsSelected, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/ClientsSelected.5ac567c8.svg";
export { ForwardRef as ReactComponent };